module.exports = __webpack_public_path__ + "static/img/smbg5.e561c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/smbg5.png
// module id = VffT
// module chunks = 1